import {
  FloatingSearchButton,
  MenuButton,
} from "~/components/Header/Buttons";
import DesktopSearchbar from "~/components/Header/DesktopSearchbar";
import { signal } from "~/sdk/signal";

import CartButtonVTEX from "~/components/Header/Buttons/Cart/vtex";

import { Props as FloatingSearchButtonProps } from "~/components/search/FloatingSearchButton";

import Image from "~/components/ui/Image";
import { useState } from "react";
import type { MenuNavigationItem } from "./types";

interface Props {
  items: MenuNavigationItem[];
  searchbar?: FloatingSearchButtonProps;
  logo?: {
    src: string;
    alt: string;
    logoWidth?: number;
    logoHeight?: number;
    url?: string;
  };
  b2bButton?: B2BButton;
  rulesBarText?: string;
  translucentEffect: boolean;
}

export interface B2BButton {
  url: string;
  text: string;
}

function Navbar({
  items,
  searchbar,
  logo,
  b2bButton,
  rulesBarText: _rulesBarText,
  translucentEffect,
}: Props) {
  const [isDesktopSearchVisible] = useState(() => signal(false));

  const miniSearchLoader = searchbar?.loader
    ? {
      ...searchbar.loader,
      id: "mini-search",
    }
    : undefined;

  const desktopSearchLoader = searchbar?.loader
    ? {
      ...searchbar.loader,
      id: "desktop-search",
    }
    : undefined;

  const miniSearchbarProps = searchbar && miniSearchLoader
    ? {
      ...searchbar,
      loader: miniSearchLoader,
    }
    : undefined;

  const desktopSearchbarProps = searchbar && desktopSearchLoader
    ? {
      ...searchbar,
      loader: desktopSearchLoader,
    }
    : undefined;

  return (
    <>
      {/* Mobile Version */}
      <div className="lg:hidden h-20 flex flex-row justify-between items-center border-b border-base-200 w-full px-[18px]">
        <div className="flex align-center justify-start w-[20%]">
          <MenuButton />
        </div>

        {logo && (
          <a
            href={logo.url || "/"}
            className="grow inline-flex items-center justify-center min-h-20"
            aria-label="Store logo"
          >
            <Image
              loading="lazy"
              fetchPriority="low"
              className="logoImage"
              src={logo.src}
              alt={logo.alt}
              width={150}
              height={43}
            />
          </a>
        )}

        <div className="flex align-center w-[20%] justify-between">
          {miniSearchbarProps && (
            <div>
              <FloatingSearchButton {...miniSearchbarProps} />
            </div>
          )}
          <CartButtonVTEX />
        </div>
      </div>

      {/* Desktop Version — linha única: logo + categorias/busca + conta/carrinho */}
      <div className="hidden lg:block">
        <div
          className={`flex header-navmenu-scroll px-4 2xl:px-[70px] gap-4 2xl:gap-0 py-4 lg:min-h-[88px]`}
        >
          {desktopSearchbarProps && (
            <DesktopSearchbar
              {...desktopSearchbarProps}
              items={items}
              isSearchVisible={isDesktopSearchVisible}
              translucentEffect={translucentEffect}
              b2bButton={b2bButton}
              platform="vtex"
              logo={logo}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;
